const segment = (value: string): string => encodeURIComponent(value);

export const CTL_ENDPOINTS = {
  SETTINGS_ME: '/v2/notifications/settings/me',
  FEED_ME: '/v2/notifications/feed/me',
  ISSUE_START: (issueId: string) => `/v2/notifications/issues/${segment(issueId)}/start`,
  ISSUE_TAKE_OVER: (issueId: string) => `/v2/notifications/issues/${segment(issueId)}/take-over`,
  LANDING: (token: string) => `/v2/notifications/landing/${segment(token)}`,
  STREAM: '/v2/notifications/stream',
  LANDING_STREAM: (token: string) => `/v2/notifications/landing/${segment(token)}/stream`,
  PUSH_SUBSCRIPTIONS: '/v2/notifications/push/subscriptions',
  PLANT_POLICY: (plantId: string) => `/v2/notifications/plants/${segment(plantId)}/policy`,
  PLANT_ROUTING: (plantId: string) => `/v2/notifications/plants/${segment(plantId)}/routing`,
  PLANT_PERSON_CHANNEL: (plantId: string, userId: string) =>
    `/v2/notifications/plants/${segment(plantId)}/people/${segment(userId)}/channel`,
} as const;
